import React, { FC } from 'react';
import { useNavigationContext, NavigationType } from 'app/components/header/navigation/Navigation';
import { HeaderItem } from 'app/components/header/navigation/HeaderNavigation';
import { DropdownItem } from 'app/components/header/navigation/DropdownNavigation';
import { DrawerItem } from 'app/components/header/navigation/DrawerNavigation';

// Keep interface around so it is easy to declare shared properties.
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface INavigationItemProps {
}

/**
 * A simple navigation item that can hold anything. Has correct padding. Is mainly used to display buttons.
 */
const NavigationItem: FC<INavigationItemProps> = props => {
  const context = useNavigationContext();
  if (!context) return null;

  switch (context.type) {
    case NavigationType.Drawer:
      return <DrawerItem {...props} />;
    case NavigationType.Dropdown:
      return <DropdownItem {...props} />;
    case NavigationType.Header:
      return <HeaderItem {...props} />;
  }
};

export default NavigationItem;
